import { FC, useEffect, useState } from "react";
import { Legend, ResponsiveContainer, Tooltip, Treemap } from "recharts";
import { TreemapNode } from "recharts/types/util/types";

import './index.css'
import { ErrorResults } from "../../../../shared/components";
import { Spin } from "antd";
import HomeService from "../../../../shared/services/home";
import { COLORS } from "../../../../config/themes/colors";
import { CustomTooltip } from "../../../../shared/components/Charts";

interface TreeChartValues {
    name: string;
    size: number;
}

export const TreeChartHome: FC = () => {
    const [currentWallet, setCurrentWallet] = useState<TreeChartValues[]>([]);
    const [showErrorTreeChart, setShowErrorTreeChart] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    const getCurrentWallet = async () => {
        setIsLoading(true);
        try {
            const response = await HomeService.getCurrentProduction();
            
            setCurrentWallet(
                response.ramas.map((item) => ({
                    name: item.descripcion,
                    size: parseInt(item.cantidad!),
                }
            )));
            
        } catch (error) {            
            setShowErrorTreeChart(true);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getCurrentWallet();
    }, []);

    const COLORS_: string[] = [
        COLORS.primary[50],
        COLORS.secondary[70],
        COLORS.accents.dark_red[30],
        COLORS.accents.light_blue[50],
        COLORS.accents.blue[50],
        COLORS.accents.dark_red[50],
        COLORS.accents.ochre[70],
        COLORS.accents.light_blue[100],
        COLORS.accents.yellow_ochre[50],
    ];

    const CustomTreemapCell = (props: TreemapNode) => {
        const { x, y, width, height, index, name, root, value } = props;
        const [hovered, setHovered] = useState(false);
    
        return (
            <g
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ color: 'black' }}
            >
                <rect
                    x={x}
                    y={y}
                    width={width}
                    height={height}
                    fill={COLORS_[index % COLORS_.length]}
                    stroke="#fff"
                    fontSize={14}
                    filter={hovered ? "brightness(105%)" : ""}
                />
                {width > 40 && height > 20 && (
                    <text
                        x={x + width / 2}
                        y={y + height / 2}
                        textAnchor="middle"
                        fill="black"
                        fontSize={14}
                    >
                        {value}
                    </text>
                )}
            </g>
        );
    };
    const CustomPieChartCell = (payload: any) => {        
        if (payload.length === 0) return '';
        return payload[0].payload.name;
    };

    return (
        isLoading ?
        <div className="tree-chart-loading-container">
            <Spin size="large" /> 
        </div> :
        showErrorTreeChart ? <ErrorResults title="No se pudo cargar el grafico de Producción Vigente" /> :
        <ResponsiveContainer>
            <div className="tree-map">
                {/* @ts-ignore */}
                <Treemap
                    width={900}
                    height={290}
                    data={currentWallet}
                    dataKey="size"
                    colorPanel={COLORS}
                    animationDuration={500}
                    content={(props:any) => <CustomTreemapCell {...props} />}
                >
                    <Tooltip
                        content={(props) => {
                            return (
                                <CustomTooltip
                                    label={CustomPieChartCell(props.payload)}
                                    hoveredElement={props.payload}
                                />
                            );
                        }}
                    />
                </Treemap>
                <div className="tree-map__legend">
                    <Legend
                        verticalAlign="top" 
                        align="right" 
                        layout="vertical"
                        iconSize={9}
                        wrapperStyle={{ position: "relative" }}
                        payload={currentWallet.map((entry, index) => ({
                            value: entry.name,
                            type: "rect",
                            color: COLORS_[index % COLORS_.length],
                        }))}
                    />
                </div>
            </div>
        </ResponsiveContainer>
      );
}
